import { LANGUAGE_DEFAULT } from '@src/configs/const.config'
import { TCreateGame, TPatchGame, TQueryGame, TQueryLoaderByBoardGame } from '@src/modules'
import { TCreateWheelGame, TPatchWheelGame, TQueryWheelGame, TQueryWheelGameUser } from '@src/modules/game-wheel'

import { request } from './config'

export const createGame = (data: TCreateGame) => request({ url: 'contest', method: 'POST', data })
export const getListGame = (params: TQueryGame, token?: string, lang = LANGUAGE_DEFAULT) =>
  request({ url: 'contest', method: 'GET', params }, { token, lang })
export const getGameById = (id: string, token?: string, lang = LANGUAGE_DEFAULT) =>
  request({ url: `contest/${id}`, method: 'GET' }, { token, lang })
export const patchGameById = (id: string, data: TPatchGame) => request({ url: `contest/${id}`, method: 'PATCH', data })
export const removeGameById = (id: string) => request({ url: `contest/${id}`, method: 'DELETE' })
export const removeManyGameByIds = (data: any) => request({ url: `contest/delete-many`, method: 'POST', data })
export const getTotalGame = (token?: string) => request({ url: `contest/total`, method: 'GET' }, { token })
export const getContestLeaderBoardById = (id: string, params: TQueryLoaderByBoardGame) =>
  request({ url: `contest-leaderboard/${id}`, method: 'GET', params })

// Wheel
export const getListWheelGameUser = (params: TQueryWheelGameUser) =>
  request({ url: 'contest-wheel-user', method: 'GET', params })
export const getListWheelGameByGameId = (params: TQueryWheelGame, gameId: string) =>
  request({ url: `contest-wheel/find-all/${gameId}`, method: 'GET', params })
export const getTotalWheelGameByGameId = (gameId: string) =>
  request({ url: `contest-wheel/total/${gameId}`, method: 'GET' })
export const createWheelGame = (data: TCreateWheelGame) => request({ url: 'contest-wheel', method: 'POST', data })
export const getWheelGameById = (id: string) => request({ url: `contest-wheel/${id}`, method: 'GET' })
export const patchWheelGameById = (id: string, data: TPatchWheelGame) =>
  request({ url: `contest-wheel/${id}`, method: 'PATCH', data })
export const removeWheelGameById = (id: string) => request({ url: `contest-wheel/${id}`, method: 'DELETE' })
